$(document).ready(function(){
	
  	$('.spr-reviews').loading();
  
  	$('.vt-reviews-list #judgeme_product_reviews').loading();
  	var SPR_READY = setInterval(function(){
    	
      	if(window.SPR || $('.jdgm-rev-widg__reviews').length){
                  	
          	clearInterval(SPR_READY);
          	//setTimeout(function(){
                initReviewsSlider()
                $('.vt-reviews-list #judgeme_product_reviews').stopLoading();
            //}, 500)
          
        }
      
    }, 300)

}).on('click', '.spr-summary-actions-newreview', function(){
	var form = $('.spr-form form').clone();
  	
  	openModal({
      body:form
    })
    
}).on('click', '.jdgm-write-rev-link', function(){
	var form = $('.jdgm-form-wrapper form').clone();
  	
  	openModal({
      body:form
    })
    
}).on('submit', '.new-review-form', function(){
	var submitted = SPR.submitForm($(this)[0]);
  	openModal({
      body:'<h2 class="text-center">Review was successfully submitted</h2>'
    })
}).on('click', '.spr-pagination a', function(){
  $('html, body').animate({scrollTop:0})
  	return false
});

function initReviewsSlider(){
	$('.vt-reviews .spr-reviews').find('.spr-pagination').remove();
    $('.vt-reviews .spr-review').each(function(){

      $(this).find('.spr-review-header-byline').before($(this).find('.spr-review-content'))

    })
    
    $('.vt-reviews .jdgm-rev').each(function(){

      $(this).find('.jdgm-rev__author-wrapper').before($(this).find('.jdgm-rev__content'))

    })


    $('.spr-reviews .spr-review-content-body').addClass('spr-review-content-body-truncate')
    $('#shopify-product-reviews').find('.btn-primary, .spr-summary-actions-newreview').addClass('btn btn-secondary').removeClass('btn-primary')
    
    
    $('.vt-reviews .spr-reviews').flickity({
          adaptiveHeight: true,
          wrapAround: true,
          freeScroll: true,
          contain: true
    });
  
  	$('.vt-reviews-list .jdgm-rev-widg__reviews').flickity({
          adaptiveHeight: true,
          wrapAround: true,
          freeScroll: true,
          contain: true
    });
}